<template>
  <div>
   
    <span>{{ message }}</span>

    <svg v-if="showWheel" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
      <path fill="#ffffff" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
        <animateTransform attributeType="xml"
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.6s"
          repeatCount="indefinite"
        />
      </path>
    </svg>
     <img src="/img/icons/logo-pug.png">
  </div>
</template>

<script>
export default {
  name: 'Loading',

  props: {
    message: {
      type: String
    },

    showWheel: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
  div {
    position: fixed;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
    background: rgba($gray, .99);
    background: white;
    color: $white;
    z-index: 1;
  }

  span {
    margin-bottom: 1rem;
    font-size: $medium-font-size;
  }
</style>
